export default __webpack_public_path__ + "static/media/team_penguin_4.7d4139f1.jpg";